import {fetchJson} from 'xenon-egress-api';

const jsonHeaders = {
  'content-type': 'application/json'
};

function buildBody(name, parameters = {}) {
  return JSON.stringify({
    name,
    parameters
  });
}

function authenticatedPost(apiUrl, path, token, body) {
  if (!token) {
    return Promise.reject(new Error('No token and authenticated!'));
  }
  return fetchJson(`${apiUrl}/${path}`, {
    method: 'POST',
    headers: jsonHeaders,
    accessToken: token,
    body
  });
}

function PromptViewApi(apiUrl) {
  return {
    fetch({data} = {}) {
      const {token} = data || {};
      return authenticatedPost(
        apiUrl,
        'prompt_view',
        token,
        buildBody('ApiPromptView', {token})
      );
    }
  };
}

function AgentReportViewApi(apiUrl) {
  return {
    fetch({data} = {}) {
      const {token, promptName} = data || {};
      return authenticatedPost(
        apiUrl,
        'agent_report_view',
        token,
        buildBody('ApiAgentReportView', {token, promptName})
      );
    }
  };
}

function PromptSaveApi(apiUrl) {
  return {
    fetch({data} = {}) {
      const {token, name, prompt, targetOutcome, tags, sequence, headless} = data || {};
      return authenticatedPost(
        apiUrl,
        'prompt_save',
        token,
        buildBody('ApiPromptSave', {token, name, prompt, targetOutcome, tags, sequence, headless})
      );
    }
  };
}

function PromptEditApi(apiUrl) {
  return {
    fetch({data} = {}) {
      const {token, name, prompt, targetOutcome, tags, sequence, headless} = data || {};
      return authenticatedPost(
        apiUrl,
        'prompt_edit',
        token,
        buildBody('ApiPromptEdit', {token, name, prompt, targetOutcome, tags, sequence, headless})
      );
    }
  };
}

function PromptDeleteApi(apiUrl) {
  return {
    fetch({data} = {}) {
      const {token, name, revisionUuid} = data || {};
      return authenticatedPost(
        apiUrl,
        'prompt_delete',
        token,
        buildBody('ApiPromptDelete', {token, name, revisionUuid})
      );
    }
  };
}

export {PromptViewApi, AgentReportViewApi, PromptSaveApi, PromptEditApi, PromptDeleteApi};
